// extracted by mini-css-extract-plugin
module.exports = {"root":"Image_root__1DgF-","round":"Image_round__2ZwBp","border":"Image_border__mYLPU"};